import { createBrowserRouter, Navigate } from 'react-router-dom'

import Root from '@/components/Router/Root'
import MainTemplate from '@/templates/MainTemplate'
import ErrorPage from '@/pages/Error'

import { authRoutes } from './auth.routes'
import { publicRoutes } from './public.routes'
import { protectedRoutes } from './protected.routes'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <MainTemplate />,
        children: [authRoutes, ...publicRoutes, protectedRoutes, { path: '*', element: <Navigate to="/" replace /> }],
      },
    ],
  },
])

export default router
